import NavMenu from './nav-menu.js'
import PopupFootnotes from './popup-footnotes.js'
import TableOfContents from './table-of-contents.js'
import DetailsToggle from './details-toggle.js'
import FormValidator from './form-validator.js'



const headerNavEl = document.querySelector('#header-nav')
if (
  headerNavEl
    && document.documentElement.dataset.es11 === 'true'
) {
  new NavMenu()
}

const popupFootnotes = document.querySelectorAll('[data-popup-footnotes]')
if (
  popupFootnotes
    && 'IntersectionObserver' in window
    && document.documentElement.dataset.es11 === 'true'
) {
  for (let fnList of popupFootnotes) {
    new PopupFootnotes(fnList)
  }
}

const tablesOfContents = document.querySelectorAll('[data-toc]')
if (
  tablesOfContents
    && 'IntersectionObserver' in window
) {
  for (let toc of tablesOfContents) {
    new TableOfContents(toc)
  }
}

const detailsToggleContainers = document.querySelectorAll('[data-details-toggle-root]')
if (detailsToggleContainers) {
  for (let detailsContainer of detailsToggleContainers) {
    new DetailsToggle(detailsContainer)
  }
}

const formElements = document.querySelectorAll('form')
if (
  formElements
    && document.documentElement.dataset.es8 === 'true'
) {
  formElements.forEach(form => {
    if (form.hasAttribute('data-form-validate')) {
      new FormValidator(form)
    }
  })
}



/******************* Django i18n *******************/

// This is just a check to see whether Django jsi18n has been loaded, to give a
// clear error message rather than (or at least before) a bunch of confusing
// errors later on.
if (!window.django) {
  console.error("window.django not defined - ensure Django's jsi18n is loaded before this script")
}

